module.exports = __webpack_public_path__ + "static/media/note.f35b8f34.svg";